export const LOAD_CONTENT = 'hg/moversReview/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/moversReview/DL_PAGE_LOADED';
export const SET_DATA = 'hg/moversReview/SET_DATA';
export const SUBMIT_ORDER = 'hg/moversReview/SUBMIT_ORDER';

const initialState = {
  content: {
    currentEquipment: {
      equipments: []
    }
  }
};

export const moversReview = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};

export const submitOrder = () => {
  return {
    type: SUBMIT_ORDER
  };
};

export default moversReview;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/review/review.js
 **/